module.exports = __webpack_public_path__ + "img/appBrand--ax-full.f8385657.svg";